/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Hold_DoneInputs */

const en_wb_hold_done = /** @type {(inputs: Wb_Hold_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept for later`)
};

const lv_wb_hold_done = /** @type {(inputs: Wb_Hold_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atstāts vēlākam`)
};

/**
* | output |
* | --- |
* | "Kept for later" |
*
* @param {Wb_Hold_DoneInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_hold_done = /** @type {((inputs?: Wb_Hold_DoneInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Hold_DoneInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_hold_done(inputs)
	return en_wb_hold_done(inputs)
});